import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMagnifyingGlass = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 16,
	viewBox: "0 0 24 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			transform: "translate(8)",
			style: { mixBlendMode: "multiply" }
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M18.6744 10.6744L23 15M20.1534 6.57669C20.1534 9.65661 17.6566 12.1534 14.5767 12.1534C11.4968 12.1534 9 9.65661 9 6.57669C9 3.49677 11.4968 1 14.5767 1C17.6566 1 20.1534 3.49677 20.1534 6.57669Z",
			stroke: "#001489",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgMagnifyingGlass);
export default ForwardRef;
